import { getField, updateField } from 'vuex-map-fields';
import axios from 'axios';
import get from 'lodash/get';

const state = {
    discount_amount: 0,
    rows: [
        {
            id: Date.now(),
            product_sku: '',
            quantity: 1,
            product: null,
            product_name: null,
            product_id: null,
            product_unit_id: null,
            sales_price: 0,
            total_price: 0,
            isLoading: false,
            type: 'product',
            height: null,
            width: null,
            results: [],
        },
    ],
};

const getters = {
    getField,

    prices: ({ rows }) => rows.filter(row => row.type === 'product').map(row => (row.sales_price * row.quantity)),

    totalPrice: (state, { prices }) => prices.reduce((sum, current) => sum + current, 0) - state.discount_amount,

    taxes: (state, { totalPrice }) => totalPrice / 121 * 21,

    subtotalPrice: (state, { totalPrice, taxes }) => totalPrice - taxes,

    prePay: (state, { totalPrice }) => totalPrice * 0.10,
};

const actions = {
    addProductRow({ commit }, row) {
        commit('addProductRow', {
            id: get(row, 'id', Date.now()),
            product_sku: get(row, 'product_sku', ''),
            quantity: get(row, 'quantity', 1),
            product: {
                id: get(row, 'product_id'),
                name: get(row, 'product_name'),
            },
            product_id: get(row, 'product_id'),
            product_name: get(row, 'product_name'),
            sales_price: get(row, 'sales_price', 0),
            total_price: get(row, 'total_price', 0),
            isLoading: false,
            type: 'product',
            results: [],
        });
    },

    addCommentRow({ commit }, row) {
        commit('addCommentRow', {
            id: get(row, 'id', Date.now()),
            isLoading: false,
            comment: '',
            type: 'comment',
        });
    },

    findRows({ commit }, id) {
        return axios.get(window.route('api.orders.show', id))
            .then(({ data }) => {
                commit('setRows', data.rows);
                commit('setDiscount', data.discount_amount);
            });
    },

    removeRow({ commit }, row) {
        commit('removeRow', row);
    },
};

const mutations = {
    updateField,

    addProductRow(state, row) {
        state.rows.push(row);
    },

    addCommentRow(state, row) {
        state.rows.push(row);
    },

    removeRow(state, row) {
        const index = state.rows.findIndex(c => c.id === row.id);
        state.rows.splice(index, 1);
    },

    setRows(state, rows) {
        state.rows = rows;
    },

    setDiscount(state, value) {
        state.discount_amount = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
